export default "__VITE_ASSET__CTBEDsRM__"